import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useBreadcrumbs } from "@/lib/breadcrumbs";

/**
 * Kopfleiste: ausschliesslich der Breadcrumb.
 *
 * Modul 38 / A9 (2026-08-17): Hier standen zwei Attrappen aus dem Geruest — ein Knopf
 * „Produkt anlegen" ohne jeden Handler und eine Glocke mit fest einprogrammierter „4".
 * Beide sind entfernt.
 *
 * Warum das nicht Kosmetik ist: ein Knopf, der nichts tut, und eine Zahl, die nichts zaehlt,
 * behaupten Funktionen, die es nicht gibt. Wer einmal auf die „4" geklickt und nichts
 * gefunden hat, glaubt der naechsten Meldung auch nicht mehr — und die Glocke soll spaeter
 * als eigenes Modul mit ECHTEN, quellenbezeichneten Meldungen zurueckkommen
 * (Leiter-Inbox, offene Wareneingaenge, Dokumenten-Inbox). Eine leere Kopfleiste ist
 * ehrlicher als eine, die luegt.
 */
export function StahliaTopBar() {
  const crumbs = useBreadcrumbs();

  return (
    <header className="h-14 border-b border-line bg-background flex items-center px-6 sticky top-0 z-30">
      <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-sm min-w-0">
        {crumbs.map((c, i) => (
          <span key={i} className="flex items-center gap-1.5 min-w-0">
            {i > 0 && <ChevronRight className="size-3.5 text-muted shrink-0" />}
            {c.href ? (
              <Link to={c.href} className="text-ink-2 hover:text-ink truncate">
                {c.label}
              </Link>
            ) : (
              <span className="text-ink font-medium truncate">{c.label}</span>
            )}
          </span>
        ))}
      </nav>
    </header>
  );
}
